export enum UserTypeEnum {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN = 'ADMIN',

  CONSUMER = 'CONSUMER',
  SYSTEM_USER = 'SYSTEM_USER',
  INSTITUTION_ADMIN = 'INSTITUTION_ADMIN',
  INSTITUTION_USER = 'INSTITUTION_USER',
  SERVICE_PROVIDER_USER = 'SERVICE_PROVIDER_USER',
}
